/* eslint-disable */

import Vue from 'vue'
import Vuex from 'vuex'
import Api from '@/api/axios-api.js'

Vue.use(Vuex)

export default {

  //Indication chargement ponctuel
  setLoadingOn (context) {
    context.commit('LOADING_ON')
  },
  setLoadingOff (context) {
    context.commit('LOADING_OFF')
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js